<template>
    <div>
        <el-form :model="rolForm" label-width="90px">
            <v-row style="padding:1rem">
                <v-col cols="12" lg="6">
                    <el-form-item label="Perfil" prop="nombre">
                        <el-input v-model="rolForm.nombre" autocomplete="off"></el-input>
                    </el-form-item>
                </v-col>
            </v-row>
            <el-skeleton v-if="dialogLoader" :rows="13" animated />
        </el-form>
        <v-row style="padding: 1rem">
            <v-col cols="12" lg="12" style="display: flex; justify-content: center;margin-bottom: 2rem;">
                <el-transfer v-model="value" :data="dataComponentes">
                </el-transfer>
            </v-col>
        </v-row>
        <span slot="footer" class="dialog-footer" style="display: flex; justify-content: end;">
            <el-button @click="closeEdit">Cancelar</el-button>
            <el-button type="primary" @click="save" v-if="nuevoHorarioPersonal">Confirmar</el-button>
            <el-button type="primary" @click="edit" v-if="!nuevoHorarioPersonal">Guardar</el-button>
        </span>
        <v-dialog v-model="dialogLoader" persistent width="300" style="padding: 1rem;overflow: hidden !important;"
            class="loading-loader">
            <v-progress-circular :size="80" color="primary" :width="5" indeterminate></v-progress-circular>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios";
export const RUTA_SERVIDOR = process.env.VUE_APP_API;
export const USUARIO = process.env.VUE_APP_USERNAME;
export const PASSWORD = process.env.VUE_APP_PASSWORD;
export const RUTA_API = process.env.VUE_APP_API;
import Swal from "sweetalert2";
export default {/* 
    props: ["periodoActual", "personalActual"], */
    data() {
        const generateData = _ => {
            const data = [];
            for (let i = 1; i <= 15; i++) {
                data.push({
                    key: i,
                    label: `Option ${i}`,
                    disabled: false
                });
            }
            return data;
        };
        return {
            rolForm: {
                nombre: null
            },
            value: [],
            data: generateData(),
            dialogLoader: false,
            dataPaciente: [],
            nuevoHorarioPersonal: false,
            totalHorasAsistenciales: 0,
            totalHorasExtra: 0,
            horasTotales: 0,
            totalHorarioSuma: 0,
            totalGuardiaSuma: 0,
            dataComponentes: [],
            idSystem:null
        };
    },
    watch: {},
    methods: {
        detectarBorrado(event, item, campo) {
            // Backspace = 8, Delete = 46
            if (event.key === 'Backspace' || event.key === 'Delete') {
                console.log('Se presionó borrar');
                item[campo] = "";
                this.calcularHoras(campo);
                // Puedes agregar lógica personalizada aquí si lo necesitas
            }
        },
        formatearHoras(item, campo) {
            const raw = item[campo].replace(/[^0-9]/g, '').slice(0, 8); // Solo números, máx 8 caracteres

            if (raw.length === 2) {
                const h1 = raw.slice(0, 2);
                item[campo] = `${h1}:`;
            } else if (raw.length === 4) {
                const h1 = raw.slice(0, 2);
                const m1 = raw.slice(2, 4);
                item[campo] = `${h1}:${m1} A `;
            } else if (raw.length === 6) {
                const h1 = raw.slice(0, 2);
                const m1 = raw.slice(2, 4);
                const h2 = raw.slice(4, 6);
                item[campo] = `${h1}:${m1} A ${h2}:`;
            } else if (raw.length === 8) {
                const h1 = raw.slice(0, 2);
                const m1 = raw.slice(2, 4);
                const h2 = raw.slice(4, 6);
                const m2 = raw.slice(6, 8);
                item[campo] = `${h1}:${m1} A ${h2}:${m2}`;
                this.calcularHoras(campo);
            }

            if (raw.length === 0) {
                this.calcularHoras(campo);
            }
        },

        save() {
            this.dialogLoader = true;
            for (let index = 0; index < this.dataPaciente.length; index++) {
                const element = this.dataPaciente[index];
                axios
                    .post(RUTA_API + "/rrhh_planilla_dias_horario/", element)
                    .then((res) => {
                        if (this.dataPaciente.length == index + 1) {
                            this.dialogLoader = false;
                            this.closeEdit();
                            Swal.fire({
                                title: "¡Exito!",
                                text: "¡Se grabó correctamente!",
                                icon: "success",
                                confirmButtonText: "Aceptar"
                            });
                        };
                    })
                    .catch((res) => {
                        console.log("Error:", res);
                    });
            }
        },
        edit() {
            this.dialogLoader = true;
            for (let index = 0; index < this.dataPaciente.length; index++) {
                const element = this.dataPaciente[index];
                axios
                    .patch(RUTA_API + "/rrhh_planilla_dias_horario/" + element.id + "/", element)
                    .then((res) => {
                        this.closeEdit();
                        if (this.dataPaciente.length == index + 1) {
                            this.dialogLoader = false;
                            Swal.fire({
                                title: "¡Exito!",
                                text: "¡Se editó correctamente!",
                                icon: "success",
                                confirmButtonText: "Aceptar"
                            });
                        };
                    })
                    .catch((res) => {
                        console.log("Error:", res);
                    });
            }
        },
        formatearHoras(item) {
            const raw = item.horas_horario.replace(/[^0-9]/g, '').slice(0, 8); // Solo números, máx 8 caracteres

            if (raw.length === 2) {
                const h1 = raw.slice(0, 2);
                item.horas_horario = `${h1}:`;
            }
            if (raw.length === 4) {
                const h1 = raw.slice(0, 2);
                const m1 = raw.slice(2, 4);
                item.horas_horario = `${h1}:${m1} A `;
            }
            if (raw.length === 6) {
                const h1 = raw.slice(0, 2);
                const m1 = raw.slice(2, 4);
                const h2 = raw.slice(4, 6);
                item.horas_horario = `${h1}:${m1} A ${h2}:`;
            }
            if (raw.length === 8) {
                const h1 = raw.slice(0, 2);
                const m1 = raw.slice(2, 4);
                const h2 = raw.slice(4, 6);
                const m2 = raw.slice(6, 8);
                item.horas_horario = `${h1}:${m1} A ${h2}:${m2}`;
                this.calcularHoras();
            }

            if (raw.length === 0) {
                this.calcularHoras();
            }
        },
        calcularHorasExtrasHE25(item) {
            if (item.he_25.slice(0, 1) == 0) {
                item.he_25 = item.he_25.slice(1, 2);
            }
            if (item.he_25 == '') {
                item.he_25 = 0;
            }
            this.totalHorasExtra = this.dataPaciente.reduce((total, item) => {
                return total + Number(item.he_25 || 0) + Number(item.he_35 || 0); // aseguras que es número
            }, 0);
            this.horasTotales = this.totalHorasExtra + this.totalHorasAsistenciales;
        },
        calcularHorasExtrasHE35(item) {
            if (item.he_35.slice(0, 1) == 0) {
                item.he_35 = item.he_35.slice(1, 2);
            }
            if (item.he_35 == '') {
                item.he_35 = 0;
            }
            this.totalHorasExtra = this.dataPaciente.reduce((total, item) => {
                return total + Number(item.he_35 || 0) + Number(item.he_25 || 0); // aseguras que es número
            }, 0);
            this.horasTotales = this.totalHorasExtra + this.totalHorasAsistenciales;
        },
        calcularHoras(nombreItem) {
            const totalSuma = this.dataPaciente.reduce((total, item) => {
                if (!item[nombreItem] || !item[nombreItem].includes(" A ")) return total;

                const [inicio, fin] = item[nombreItem].split(" A ");
                const [hInicio, mInicio] = inicio.split(":").map(Number);
                const [hFin, mFin] = fin.split(":").map(Number);

                if (isNaN(hInicio) || isNaN(mInicio) || isNaN(hFin) || isNaN(mFin)) return total;

                const inicioMin = hInicio * 60 + mInicio;
                const finMin = hFin * 60 + mFin;

                const diferencia = finMin - inicioMin;
                const horas = diferencia / 60;

                return total + (horas > 0 ? horas : 0); // suma solo si es positivo
            }, 0);

            if (nombreItem == 'horas_horario') {
                this.totalHorarioSuma = totalSuma;
            } else {
                this.totalGuardiaSuma = totalSuma;
            }

            this.totalHorasAsistenciales = this.totalHorarioSuma + this.totalGuardiaSuma;
            this.horasTotales = Number(this.totalHorasExtra || 0) + this.totalHorasAsistenciales;
        },
        dataInit() {
            this.dialogLoader = true;
            axios
                .get(RUTA_API + "/seguridad_componentes/?system="+this.idSystem)
                .then((res) => {
                    this.dialogLoader = false;
                    this.dataComponentes = res.data;
                    this.dataComponentes = this.dataComponentes.map(item => ({
                        key: item.id,
                        label: item.nombre
                    }));
                })
                .catch((res) => {

                });
        },
        nuevoHorario() {
            this.dialogLoader = true;
            axios
                .get(RUTA_API + "/rrhh_planilla_dias/periodo/?periodo=" + this.periodoActual)
                .then((res) => {
                    this.dialogLoader = false;
                    this.dataPaciente = res.data;
                    this.dataPaciente = this.dataPaciente.map(dia => ({
                        ...dia,
                        dias_id: dia.id,
                        horas_guardia: '',
                        horas_horario: '',
                        rango_horario: '',
                        rango_guardia: '',
                        tipo: '',
                        he_25: '',
                        he_35: '',
                        es_jefe: false,
                        personal_id: ""
                    }));
                    console.log("Personal", this.dataPaciente);
                })
                .catch((res) => {
                    console.log("Error:", res);
                });
        },
        closeEdit() {
            this.$emit('closedialogForm');
        },
        submitForm() {

        }
    },
    mounted() { },
    computed: {
        filteredHeaders() {
            return this.headers;
        },

    },
    created() {
        this.idSystem=sessionStorage.getItem("idSystem");
        this.dataInit();
    },
    components: {},
};
</script>
<style scoped>
::v-deep .v-overlay__scrim {
    opacity: 0.5 !important;
    background-color: rgba(203, 25, 25, 0.54) !important;
    border-color: rgb(255 255 255) !important;
}

::v-deep .v-overlay {
    z-index: 99 !important;
}

::v-deep .loading-loader {
    z-index: 99 !important;
}

::v-deep .v-dialog {
    display: flex;
    justify-content: center;
    box-shadow: none;
    overflow-y: hidden !important;
}

::v-deep .el-form-item__label {
    text-align: right;
    vertical-align: middle;
    float: left;
    font-size: 14px;
    color: #606266;
    line-height: 40px !important;
    /*  line-height: 28px !important; */
    margin-left: 0 !important;
    padding: 0 12px 0 0;
    box-sizing: border-box;
}

::v-deep .el-form-item--mini.el-form-item,
.el-form-item--small.el-form-item {
    margin-bottom: 7px !important;
}

::v-deep .el-dialog__body {
    padding: 0px !important;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}

::v-deep .col-xl,
.col-xl-auto,
.col-xl-12,
.col-xl-11,
.col-xl-10,
.col-xl-9,
.col-xl-8,
.col-xl-7,
.col-xl-6,
.col-xl-5,
.col-xl-4,
.col-xl-3,
.col-xl-2,
.col-xl-1,
.col-lg,
.col-lg-auto,
.col-lg-12,
.col-lg-11,
.col-lg-10,
.col-lg-9,
.col-lg-8,
.col-lg-7,
.col-lg-6,
.col-lg-5,
.col-lg-4,
.col-lg-3,
.col-lg-2,
.col-lg-1,
.col-md,
.col-md-auto,
.col-md-12,
.col-md-11,
.col-md-10,
.col-md-9,
.col-md-8,
.col-md-7,
.col-md-6,
.col-md-5,
.col-md-4,
.col-md-3,
.col-md-2,
.col-md-1,
.col-sm,
.col-sm-auto,
.col-sm-12,
.col-sm-11,
.col-sm-10,
.col-sm-9,
.col-sm-8,
.col-sm-7,
.col-sm-6,
.col-sm-5,
.col-sm-4,
.col-sm-3,
.col-sm-2,
.col-sm-1,
.col,
.col-auto,
.col-12,
.col-11,
.col-10,
.col-9,
.col-8,
.col-7,
.col-6,
.col-5,
.col-4,
.col-3,
.col-2,
.col-1 {
    width: 100%;
    padding: 0px;
}

::v-deep .el-input--mini .el-input__inner {
    height: 28px;
    line-height: 28px;
    text-align: center;
    padding: .2rem;
}

::v-deep tr td {
    text-wrap: nowrap !important;
    padding: .05rem .2rem !important;
}
</style>